import {Modal as PaperModal, Portal} from 'react-native-paper';
import PropTypes from 'prop-types';

const Modal = ({
  style,
  contentContainerStyle,
  visible,
  onDismiss,
  children,
}) => {
  const mergedContentContainerStyle = {
    height: '100%',
    width: '100%',
    justifyContent: 'start',
    backgroundColor: 'white',
  };

  if (contentContainerStyle) {
    Object.assign(mergedContentContainerStyle, contentContainerStyle);
  }

  return (
    <Portal>
      <PaperModal
        contentContainerStyle={mergedContentContainerStyle}
        style={[{margin: 0}, style]}
        visible={visible}
        dismissable={false}
        onDismiss={onDismiss}>
        {children}
      </PaperModal>
    </Portal>
  );
};
Modal.propTypes = {
  style: PropTypes.any,
  contentContainerStyle: PropTypes.any,
  visible: PropTypes.any,
  onDismiss: PropTypes.any,
  children: PropTypes.any,
};

export default Modal;
